import { Controller } from 'react-hook-form';
import { Select, Autocomplete, usePrevious } from '@ui/src';
import { FeeSettingsFormTypes } from './types';
import { FeeTierEnum } from '../../hoc/bank-and-psp/types';

import cn from './info.module.css';

const FeeSettingsForm = ({
  control,
  casp,
  errors,
  setValue,
  autocompleteList,
  pagination,
  onSearch,
  isLoading,
  onClear,
  onScroll,
  searchValue,
  nextPageIsLoading,
  getAutocompleteListAction,
  panelIsOpen,
  selectedFeeTierItemId,
}: FeeSettingsFormTypes) => {
  const prevPanelIsOpen = usePrevious(panelIsOpen);

  return (
    <>
      <div className={cn.feeSettingsFormGroup}>
        <Controller
          control={control}
          defaultValue=""
          name="caspId"
          render={({ field: { value, name, onChange } }) => (
            <Select
              name={name}
              value={value}
              placeholder="Select CASP"
              title="CASP"
              list={
                casp?.map((item) => ({ name: item.name, value: item.id })) || []
              }
              onChange={onChange}
              error={errors?.caspId?.message}
              disabled={Boolean(selectedFeeTierItemId)}
            />
          )}
        />
      </div>
      <div className={cn.feeSettingsFormGroup}>
        <Controller
          control={control}
          defaultValue={FeeTierEnum.LOW}
          name="feeTier"
          render={({ field: { value, name, onChange } }) => (
            <Select
              name={name}
              value={value}
              placeholder="Select Fee Tier"
              title="Fee Tier"
              list={[
                {
                  name: 'Low',
                  value: FeeTierEnum.LOW,
                },
                {
                  name: 'Medium',
                  value: FeeTierEnum.MEDIUM,
                },
                {
                  name: 'High',
                  value: FeeTierEnum.HIGH,
                },
              ]}
              onChange={onChange}
              error={errors?.feeTier?.message}
            />
          )}
        />
      </div>
      <div className={cn.feeSettingsFormGroup}>
        <Controller
          control={control}
          defaultValue={FeeTierEnum.LOW}
          name="feeIntegrationAccountId"
          render={({ field: { value, name, onChange } }) => (
            <Autocomplete
              name={name}
              value={value}
              title="External Account"
              placeholder="Enter number or iban..."
              list={autocompleteList}
              onChange={onChange}
              isLoading={isLoading}
              onSearch={(search) => {
                if (search?.length) {
                  onSearch(search);
                } else {
                  getAutocompleteListAction();
                }
              }}
              hasNextPage={pagination?.hasNextPage}
              onInfinateScroll={() => {
                onScroll({
                  cursor: pagination?.endCursor as string,
                  search: searchValue || '',
                });
              }}
              onClearClick={() => {
                onClear();

                setValue('feeIntegrationAccountId', '');
              }}
              nextPageIsLoading={nextPageIsLoading}
              resetState={Boolean(!panelIsOpen && prevPanelIsOpen)}
              error={errors?.feeIntegrationAccountId?.message}
              withClearButton
              withInfiniteScroll
              withSuffix
              withCopySuffix
            />
          )}
        />
      </div>
    </>
  );
};

export default FeeSettingsForm;
